module.exports = __webpack_public_path__ + "static/toolsmobile-d26f5715deef8b25f5f21c5eb6667e9e.png";